import Vue from "vue";

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
Vue.use(Toast);
// Bootstrap
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

import App from "./App.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "./assets/css/common.css";
import "./assets/css/icons.css";
import store from "./store";
import router from "./router";
import { ensureAuthReady } from "./store/modules/auth";

// Kick off the session-validity check as early as possible so it's likely
// already resolved by the time a protected route's guard needs it.
ensureAuthReady(store.dispatch);
// Apply the saved (or system-default) light/dark theme before the app
// renders, so there's no flash of the wrong theme on load.
store.dispatch("initTheme");
import vuescroll from "vuescroll";

Vue.use(vuescroll);
// Note: vue-plyr, vue-responsive-video-background-player, and a global
// vue-cool-lightbox registration used to be pulled in here too, shipping on
// every single page load regardless of whether that page needed them.
// vue-plyr's <vue-plyr> usage is commented out everywhere (dead code), the
// video-background component is never referenced anywhere in the app, and
// every real CoolLightBox usage (AssetViewModal, AssetDetail,
// AssetQuickViewModal, Projects) already imports and registers it locally -
// so the global registration here was pure duplicate weight. Removed.
import "./interceptors";

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
